import { Avatar } from '@app/components/Avatar/Avatar.main';

export { Avatar };
